module.exports = __webpack_public_path__ + "img/camping_3.ce95978c.jpg";